/*
  TODO: Migrate to proper VUe3 composition api:
  https://glittrsoftware.visualstudio.com/glittr.core/_workitems/edit/8089
*/

/* eslint-disable no-use-before-define */
// which observables will be notified on tick
const notificationQueue = new Set<Observable>();
const deps = new WeakMap<any, Observable>();

export function isObservable(toCheck: any) {
  return !!toCheck.observers && !!toCheck.proxy && !!toCheck.observe && !!toCheck.unobserve;
}

export class Observable {
  observers: Set<any> | null;
  proxy: ProxyConstructor;
  // source: any;

  constructor(source: any, root?: any) {
    let complete = false;
    const self = this;
    const proxy = new Proxy(source, {
      get(target, key) {
        return target[key];
      },
      set(target, key, value) {
        if (target[key] !== value) {
          if (complete) {
            notificationQueue.add(root || self);
          }
          target[key] = value;
        }
        return true;
      },
      deleteProperty(target, key) {
        if (key in target) {
          delete target[key];
          notificationQueue.add(root || self);
          return true;
        }
        return false;
      },
    });
    // Object.keys on array only includes keys that are specifically set
    (Array.isArray(source) ? [...Array(source.length).keys()] : Object.keys(source)).forEach((key) => {
      const value = source[key];
      if (Array.isArray(value) || (typeof value === 'object' && value instanceof Object)) proxy[key] = new Observable(value, self).proxy;
    });
    this.observers = new Set<any>();
    this.proxy = proxy;
    complete = true;
  }

  observe(callback: ()=>void) {
    if (!this.observers?.has(callback)) {
      return this.observers?.add(callback);
    }
    return this.observers;
  }

  unobserve(callback: ()=>void) {
    return this.observers?.delete(callback);
  }

  clearObservers() {
    this.observers?.clear();
    this.observers = null;
  }
}

export function observe<T extends object>(source: T, callback: ()=>void, immediate: boolean = false): T {
  if (deps.has(source)) {
    const obs = deps.get(source);
    if (obs?.observers?.has(callback)) {
      // Do not observe the same callback multiple times, this is almost guaranteed to be a mistake
      // Makes it easier to use the observe function
      return source;
    }
  }
  const obs = (isObservable(source) ? source : new Observable(source)) as Observable;
  obs.observe(callback);
  // Can cast to T because it's wrapped by a proxy
  // No other way to cast it
  const proxied = obs.proxy as unknown as T;
  deps.set(proxied, obs);
  if (immediate) {
    callback();
  }
  return proxied;
}

export function unobserve(source: any, callback: ()=>void) {
  const obs = isObservable(source) ? source : deps.get(source);
  obs.unobserve(callback);
}

function tick() {
  notificationQueue.forEach((obs) => {
    obs.observers?.forEach((callback: ()=>void) => callback());
  });
  notificationQueue.clear();
  window.requestAnimationFrame(tick);
}

tick();
